export default "__VITE_ASSET__BRBMIxSy__"